module.exports = __webpack_public_path__ + "img/accordion-arrow.009a51f2.svg";